import { IPopulationCsvRowError } from 'components/admin/shared/PopulationCsvUpload/types';
import { Button } from 'components/admin/ui';
import { Alert } from 'components/ui';
import pluralHelper from 'lib/helpers/pluralHelper';
import _ from 'lodash';

interface IPopulationCsvErrorsAlertProps {
  className?: string;
  fileError?: string;
  rowErrors: IPopulationCsvRowError[];
  onClick: () => void;
}

export const PopulationCsvErrorsAlert = ({
  className,
  fileError,
  rowErrors,
  onClick,
}: IPopulationCsvErrorsAlertProps) => {
  if (fileError) {
    return (
      <Alert className={className} color="red">
        {fileError}
      </Alert>
    );
  } else if (!_.isEmpty(rowErrors)) {
    const errorCount = _.sumBy(rowErrors, (x) => _.size(x.errors));
    return (
      <Alert className={className} color="red">
        <div>
          This CSV includes{' '}
          <strong>
            {errorCount} error{pluralHelper(errorCount)}
          </strong>
          . Please fix {errorCount > 1 ? 'them' : 'it'} and reupload the file.
        </div>
        <Button variant="link" onClick={onClick}>
          Review Errors
        </Button>
      </Alert>
    );
  }
  return null;
};
